import { Button, Card, Spinner, Typography } from '@material-tailwind/react'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form';
import AInput from '../../components/fields/AInput';
import AIcon from '../../components/partials/AIcon';
import { useShared } from '../../hooks/useShared';
import { ToastContainer, toast } from 'react-toastify';

const inputFields = [
    { label: 'پاسورد فعلی', name: 'password', type: 'password', roles: [0], icon: 'eye-outline', className: '', required: true, isStyle: false, isDisabled: false, errorMsg: 'Current password is required' },
    { label: 'پاسپورد جديد', name: 'new_password', type: 'password', roles: [0], icon: 'eye-outline', className: '', required: true, isStyle: false, isDisabled: false, errorMsg: 'New password is required' },
    { label: 'تکرار پاسورد جديد', name: 'new_password_confirmation', type: 'password', roles: [0], icon: 'eye-outline', className: '', required: true, isStyle: false, isDisabled: false, errorMsg: 'assword confirmation is required' },

]

export default function ResetPassword({ v }) {
    const { auth: {setUser }, http,  } = useShared()
    const { register, handleSubmit,  formState: { errors }, } = useForm({});
    const [errorMessage, setErrorMessage] = useState(null)
    const [loading, setLoading] = useState(false)

    const submit = async (data) => {
    
        data['email'] = v.member?.email;
        console.log('password data ', data);
        setErrorMessage(null)
        setLoading(true)
        try {
            const res = await http.post('api/reset_password', data)
            if (res.data) {
                setUser(res.data);
                console.log('reset password doen ', res);
                toast.success('Your password has been reset successfully');
            }

            setLoading(false)
        } catch (error) {
            console.log("error", error);
            setLoading(false)
            const err = error?.response?.data
            if (!err?.success) {
                setErrorMessage(err?.message)
                 toast.error(err?.message);
            }
        }
    }



    return (

        <Card className=" p-2 md:p-4 mt-4 border">
            <p className="text-base text-main-color font-bold border-b pb-1 mb-3">تنظیم مجدد پاسورد</p>
            <form onSubmit={handleSubmit(submit)}>

                <div className='grid md:grid-cols-1 gap-4'>
                    {
                        inputFields?.map((data, i) => {
                            return (
                                <div key={i}>
                                    {
                                        <AInput v={{ register, errors, data }} />
                                    }
                                </div>
                            )
                        })
                    }

                    {errorMessage && <Typography
                        variant="small"
                        color="gray"
                        className="flex items-center text-red-500 gap-2 font-normal "
                    >
                        <AIcon name="alert-circle-outline" className="-mt-0.5 h-4 w-4" />
                        {errorMessage}
                    </Typography>}
                    <Button className="rounded-lg flex justify-center"  color="red" size='sm' type="submit" disabled={loading }>  {loading && <Spinner color="teal" className="h-4 w-4 mr-2" />}ارسال</Button>
                   
                </div>
            </form>
            <ToastContainer />
        </Card>

    )
}
